export default __webpack_public_path__ + "133d7e338484dc230fb906ed3692b328.svg";